import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager, setCachedAccessToken } from './userManager.js';

/** Handles the Authorization Code + PKCE redirect back from ZITADEL. */
export function CallbackPage() {
  const navigate = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    userManager
      .signinRedirectCallback()
      .then((user) => {
        setCachedAccessToken(user.access_token ?? null);
        const returnTo =
          (user.state as { returnTo?: string } | undefined)?.returnTo ?? '/tipsconnect/admin/orgs';
        navigate(returnTo, { replace: true });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Sign-in failed');
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="route-center">
        <div className="empty-state">
          <h2>Sign-in failed</h2>
          <p>{error}</p>
          <button
            type="button"
            className="btn btn--secondary"
            onClick={() => userManager.signinRedirect()}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="route-center">
      <div className="spinner" aria-label="Completing sign-in" />
    </div>
  );
}

/** Hidden-iframe target for automatic silent token renewal. */
export function SilentRenewPage() {
  useEffect(() => {
    void userManager.signinSilentCallback().catch(() => {
      /* errors are surfaced via the next API 401 */
    });
  }, []);
  return null;
}
